__turbopack_context__.v({
  "body": "kqYWpa_body",
  "icon": "kqYWpa_icon",
  "root": "kqYWpa_root",
  "title": "kqYWpa_title",
});
